import React from 'react';
import { notNil } from '../../../../core/helpers/is-nil';
import { Typography } from '../../../typography/typography';
import styles from './table-cell-unit.module.scss';

type Props = {
  value: string | null | number;
  unitLabel?: string;
  highlight?: boolean;
};

export const TableCellUnit: React.FC<Props> = ({ value, unitLabel, highlight = false }) => {
  const hasValue = notNil(value);

  return (
    <div className={styles.root}>
      {hasValue ? (
        <>
          <Typography color="black" fontStyle={highlight ? 'bold' : undefined} variant="maintext">
            {value}
          </Typography>
          {notNil(unitLabel) ? (
            <Typography color="anthrazit-75" fontStyle={highlight ? 'bold' : undefined} variant="maintext">
              {` ${unitLabel}`}
            </Typography>
          ) : null}
        </>
      ) : null}
    </div>
  );
};
